import * as apiUtils from "@/utils/apiUtils"
import moment from "moment"

export default {
  namespaced: true,
  // -----------------------------------------------------------------
  state: {},
  // -----------------------------------------------------------------
  getters: {},
  // -----------------------------------------------------------------
  mutations: {},
  // -----------------------------------------------------------------
  actions: {
    // Estimates
    getEstimate: (context, tid) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + tid
      return apiUtils
        .get(path)
        .then(function(response) {
          response.data.endDate = moment(response.data.expiredAt).format("YYYY-MM-DD")
          response.data.startDate = moment(response.data.issuedAt).format("YYYY-MM-DD")

          return Promise.resolve(response)
        })
        .catch(function(error) {
          return Promise.reject(error)
        })
    },
    getEstimates: (context, query) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates"
      return apiUtils.get(path, query)
    },
    createEstimate: (
      context,
      { name, number, currencyCode, customerId, issuedAt, expiredAt, poso, subHeader, footer, memo, items }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates"
      return apiUtils.post(path, {
        name,
        number,
        currencyCode,
        customerId,
        issuedAt,
        expiredAt,
        poso,
        subHeader,
        footer,
        memo,
        items
      })
    },
    updateEstimate: (
      context,
      { id, name, number, currencyCode, customerId, issuedAt, expiredAt, poso, subHeader, footer, memo, items }
    ) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id
      return apiUtils.patch(path, {
        name,
        number,
        currencyCode,
        customerId,
        issuedAt,
        expiredAt,
        poso,
        subHeader,
        footer,
        memo,
        items
      })
    },
    deleteEstimate: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id
      return apiUtils.delete(path)
    },
    shareEstimate: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id + "/share"
      return apiUtils.post(path)
    },
    getShareEstimate: (context, id) => {
      var path = "/shares/estimates/" + id
      return apiUtils.get(path)
    },
    sendEstimateByEmail: (context, { id, emails, from, cc }) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id + "/send-by-email"
      return apiUtils.post(path, {
        emails,
        from,
        cc
      })
    },
    duplicateEstimate: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id + "/duplicate"
      return apiUtils.post(path)
    },
    convertEstimate2Invoice: (context, id) => {
      var bid = context.rootGetters["bizes/bid"]()
      var path = "/bizes/" + bid + "/sales/estimates/" + id + "/convert-to-invoice"
      return apiUtils.post(path)
    }
  }
}
